import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component PersonListIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <PersonListIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <PersonListIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const PersonListIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="PersonListIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M17 16c1.33 0 3.216.507 3.683 2l.216.682a.5.5 0 0 1-.191.562Q19.619 20 17.005 20q-2.655 0-3.745-.78a.5.5 0 0 1-.198-.511l.15-.709c.423-1.38 2.458-2 3.788-2m0-5a2 2 0 1 1 0 4 2 2 0 0 1 0-4m-4.2 1a1 1 0 0 1-1 1H9a1 1 0 1 1 0-2h2.8a1 1 0 0 1 1 1m-1.133 5a1 1 0 0 1-1 1H9a1 1 0 1 1 0-2h1.667a1 1 0 0 1 1 1M19 6a1 1 0 1 1 0 2H9a1 1 0 0 1 0-2zM5 5.5c.83 0 1.5.67 1.5 1.5S5.83 8.5 5 8.5 3.5 7.83 3.5 7 4.17 5.5 5 5.5m0 5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5m0 5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5"
        clipRule="evenodd"
      />
    </svg>
  )
);
PersonListIcon.displayName = "PersonListIcon";
export default PersonListIcon;
